// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>11</span>&nbsp;&nbsp;No slanderer shall prosper on the earth,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and evil shall hunt down the violent to overthrow them.<br> </p> </div></div>";
// Exports
module.exports = code;